import {defineMessages} from 'react-intl';

export default defineMessages({
	results: {
		id: 'plp.search.searchResultText',
		defaultMessage: 'results for',
	}
});
